/* unplugin-vue-components disabled */import script from "./AgreementView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgreementView.vue?vue&type=script&lang=ts&setup=true"

import "./AgreementView.vue?vue&type=style&index=0&id=2bb9975a&lang=less"

const __exports__ = script;

export default __exports__